import React from 'react'
import { Box, Link, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CustomTable from 'src/components/PostGraduationContent/PostgraduateComponents/Table/CustomTable'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './SelectionTab.styles'

const Selection = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const data = [
    {
      action: 'Divulgação do resultado e da lista de selecionados',
      period: '29 de abril de 2022'
    },
    {
      action: 'Interposição de recurso ao resultado da seleção',
      period: '02 e 03 de maio de 2022'
    },
    {
      action: 'Divulgação do resultado após análise do recurso',
      period: '05 de maio de 2022'
    },
    {
      action: 'Divulgação da lista consolidada de selecionados',
      period: '06 de maio de 2022'
    },
    { action: 'Início das atividades do curso', period: '10 de maio de 2022' }
  ]
  const rows = [
    [
      <>
        Inscrições on-line no site
        <br />
        <Link
          href="https://si3.ufc.br/sigaa/public"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.si3.ufc.br/sigaa/public
        </Link>
        <br />
        <small>(selecione a aba processos seletivos - lato sensu)</small>
        <br />
        <br />
        Inscrições e envio dos documentos por meio do endereço eletrônico:
        <br />
        <Link href="/rsc/inscricao">www.lsbd.ufc.br/rsc/inscricao</Link>
      </>,
      '04 a 22 de abril de 2022'
    ],
    ...data.map((row) => [row.action, row.period])
  ]
  return (
    <>
      <Typography className={globalClasses.titleSectionVariant2}>
        {t('news.postgraduate.selc.tab-title')}
      </Typography>
      <Box className={classes.contentContainer}>
        <Typography className={classes.paragraph}>
          As inscrições estarão abertas no período 08h do dia 04 de abril de
          2022 às 23h59min do dia 22 de abril de 2022 (Inscrições prorrogadas) .
          O preenchimento da ficha de inscrição deverá ser feito pela internet,
          via SIGAA, por meio do endereço eletrônico:{' '}
          <Link
            href="https://si3.ufc.br/sigaa/public"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.si3.ufc.br/sigaa/public
          </Link>{' '}
          (selecione a aba processos seletivos - lato sensu).
        </Typography>
        <Typography className={classes.paragraph}>
          Adicionalmente, o(a) candidato(a) deverá enviar os seguintes
          documentos por meio do endereço eletrônico:{' '}
          <Link href="/rsc/inscricao">www.lsbd.ufc.br/rsc/inscricao</Link>:
        </Typography>
        <ul className={classes.dotList}>
          <li>Documento de identificação oficial com foto;</li>
          <li>
            Comprovante de inscrição gerado e emitido pelo SIGAA no ato da
            inscrição online (item 5.2);
          </li>
          <li>Termo de compromisso preenchido e assinado (Anexo I);</li>
          <li>
            Comprovante de conclusão de curso superior ou comprovante que o
            substitua, de IES reconhecida pelo MEC.
          </li>
          <li>
            Comprovante de vínculo com a Universidade Federal do Ceará, no caso
            de servidores dessa instituição;
          </li>
          <li>
            Barema curricular preenchido (Anexo II) e documentos comprobatórios
            em um único arquivo PDF;
          </li>
          <li>
            Carta de motivação (máximo de uma página) justificando o interesse
            na Residência em Segurança Cibernética.
          </li>
        </ul>
        <Typography className={classes.paragraph}>
          Veja abaixo o cronograma do processo seletivo:
        </Typography>
        <Box className={classes.tableContainer}>
          <CustomTable
            headers={[
              t('news.postgraduate.selc.action'),
              t('news.postgraduate.selc.period')
            ]}
            rows={rows}
          />
        </Box>
      </Box>
    </>
  )
}

export default Selection
